module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    staticClass: "align-items-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticStyle: {
      "position": "absolute"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    staticStyle: {
      "margin": "0"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Sea Import(Consolidation)")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [(_vm.ffExoprtDetail.conSeaImportId != '') ? _c('md-button', {
    staticClass: "md-fab",
    staticStyle: {
      "position": "fixed",
      "z-index": "999",
      "top": "83%"
    },
    on: {
      "click": _vm.addStatus
    }
  }, [_c('md-icon', [_vm._v("message")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "align-items-center pl-2 pr-2",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('label', [_c('u', [_vm._v("Job Type")])])]), _vm._v(" "), _vm._l((_vm.showSegmentArray), function(segmentNameArray, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": segmentNameArray.flex
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": segmentNameArray.value,
        "name": 'jobType' + (index + 1),
        "id": 'jobType' + (index + 1)
      },
      on: {
        "change": function($event) {
          _vm.jobTypeSelect(segmentNameArray.value, index)
        }
      },
      model: {
        value: (_vm.ffExoprtDetail.jobType[index]),
        callback: function($$v) {
          _vm.$set(_vm.ffExoprtDetail.jobType, index, $$v)
        },
        expression: "ffExoprtDetail.jobType[index]"
      }
    }, [_vm._v(_vm._s(segmentNameArray.show))])], 1)
  })], 2), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "isDisabled": "",
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select  Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.transportType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "transportType", $$v)
      },
      expression: "ffExoprtDetail.transportType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerInfo"
    }
  }, [_vm._v("FF Activity")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.containerInfoList,
      "option-value": "containerInfoVal",
      "option-text": "containerInfoText",
      "placeholder": "Select Type",
      "isDisabled": _vm.ffExoprtDetail.conSeaImportId == '' ? false : true
    },
    model: {
      value: (_vm.ffExoprtDetail.containerInfo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "containerInfo", $$v)
      },
      expression: "ffExoprtDetail.containerInfo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-end",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [(!_vm.ffExoprtDetail.containerInfo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.containerInfo))]) : _vm._e()])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping Line Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line "
    },
    model: {
      value: (_vm.ffExoprtDetail.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shippingId", $$v)
      },
      expression: "ffExoprtDetail.shippingId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Date of Sail")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "width": "100%",
      "lang": "en",
      "id": "sailDate",
      "name": "sailDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.sailDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "sailDate", $$v)
      },
      expression: "ffExoprtDetail.sailDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Pre-Alert Received Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "width": "100%",
      "lang": "en",
      "id": "alertReceivedDate",
      "name": "alertReceivedDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.alertReceivedDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "alertReceivedDate", $$v)
      },
      expression: "ffExoprtDetail.alertReceivedDate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [(!_vm.ffExoprtDetail.shippingId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.shippingId))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [(!_vm.ffExoprtDetail.sailDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.sailDate))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [(!_vm.ffExoprtDetail.alertReceivedDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.alertReceivedDate))]) : _vm._e()])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v("Ocean Vessel and Voyage")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vesselVoyage",
      "name": "vesselVoyage"
    },
    model: {
      value: (_vm.ffExoprtDetail.vesselVoyage),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "vesselVoyage", $$v)
      },
      expression: "ffExoprtDetail.vesselVoyage"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v("Pre Carriage By")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "preCarriageBy",
      "name": "preCarriageBy"
    },
    model: {
      value: (_vm.ffExoprtDetail.preCarriageBy),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "preCarriageBy", $$v)
      },
      expression: "ffExoprtDetail.preCarriageBy"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Master B/L Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "firstBLNumber",
      "name": "firstBLNumber"
    },
    on: {
      "keyup": _vm.containerNoRegexfun
    },
    model: {
      value: (_vm.ffExoprtDetail.firstBLNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstBLNumber", $$v)
      },
      expression: "ffExoprtDetail.firstBLNumber"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Master B/L Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "width": "100%",
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "firstBLDate",
      "name": "firstBLDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.firstBLDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstBLDate", $$v)
      },
      expression: "ffExoprtDetail.firstBLDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "firstBlType"
    }
  }, [_vm._v("B/L Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.blTypeList,
      "option-value": "blTypeVal",
      "option-text": "blTypeTxt",
      "placeholder": "Select B/L Type",
      "isDisabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.firstBlType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstBlType", $$v)
      },
      expression: "ffExoprtDetail.firstBlType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary",
    staticStyle: {
      "margin": "0",
      "align-self": "end",
      "padding-bottom": "0.7rem"
    },
    attrs: {
      "id": "permitted1",
      "name": "permitted1",
      "md-value": "Original"
    },
    model: {
      value: (_vm.ffExoprtDetail.firstBLRadio),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstBLRadio", $$v)
      },
      expression: "ffExoprtDetail.firstBLRadio"
    }
  }, [_vm._v("Original")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary",
    staticStyle: {
      "margin": "0",
      "align-self": "end",
      "padding-bottom": "0.7rem"
    },
    attrs: {
      "id": "permitted2",
      "name": "permitted2",
      "md-value": "seaWayBl"
    },
    model: {
      value: (_vm.ffExoprtDetail.firstBLRadio),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstBLRadio", $$v)
      },
      expression: "ffExoprtDetail.firstBLRadio"
    }
  }, [_vm._v("Sea Way")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(!_vm.ffExoprtDetail.firstBLNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.firstBLNumber))]) : (_vm.blRegexError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.blRegexError))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Ocean Freight")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.oceanFreightTermsList,
      "option-value": "oceanFreightTermsVal",
      "option-text": "oceanFreightTermsText",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.ffExoprtDetail.firstOcFreghtTerms),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstOcFreghtTerms", $$v)
      },
      expression: "ffExoprtDetail.firstOcFreghtTerms"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload B/L")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "firstBLupload",
      "id": "firstBLupload",
      "multiple": ""
    },
    on: {
      "selected": _vm.onFileChangeFirstBl
    },
    model: {
      value: (_vm.ffExoprtDetail.firstBLupload),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstBLupload", $$v)
      },
      expression: "ffExoprtDetail.firstBLupload"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.firstBlUploadView.length > 0) ? _c('md-layout', {
    staticClass: "justify-content-end",
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.firstBlUploadView), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "15"
      }
    }, [(_vm.ffExoprtDetail.conSeaImportId == '') ? _c('a', {
      attrs: {
        "href": (this.docURL) + "/dummy/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('a', {
      attrs: {
        "href": (this.docURL) + "/SeaImportCon/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "PORlocationId"
    }
  }, [_vm._v("Place of Receipt")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.IcdPOrtListNew,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Icd,Sea_Port', 'IcdPOrtList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Icd,Sea_Port', 'IcdPOrtList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PORlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PORlocationId", $$v)
      },
      expression: "ffExoprtDetail.PORlocationId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("Port of Loading")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Loading Port Name",
      "isDisabled": _vm.ffExoprtDetail.portType != 'Icd' ? true : false
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'PortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'PortLoadList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "LPlocationId", $$v)
      },
      expression: "ffExoprtDetail.LPlocationId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "cargoDestufLocationId"
    }
  }, [_vm._v("Cargo Destuffing Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.CargoDesData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Location"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'CargoDesData')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'CargoDesData')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.cargoDestufLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "cargoDestufLocationId", $$v)
      },
      expression: "ffExoprtDetail.cargoDestufLocationId"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [(!_vm.ffExoprtDetail.PORlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.PORlocationId))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [(!_vm.ffExoprtDetail.LPlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.LPlocationId))]) : _vm._e()])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "PODLocationId"
    }
  }, [_vm._v("Port of Discharge")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PortDischargeList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'getPortDischargeList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'getPortDischargeList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PODLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PODLocationId", $$v)
      },
      expression: "ffExoprtDetail.PODLocationId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("ETA @ Discharge Port")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "width": "100%",
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "etaDischargePort",
      "name": "etaDischargePort"
    },
    model: {
      value: (_vm.ffExoprtDetail.etaDischargePort),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "etaDischargePort", $$v)
      },
      expression: "ffExoprtDetail.etaDischargePort"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("ETA @ Final Destination")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "width": "100%",
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "etaFinalPort",
      "name": "etaFinalPort"
    },
    model: {
      value: (_vm.ffExoprtDetail.etaFinalPort),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "etaFinalPort", $$v)
      },
      expression: "ffExoprtDetail.etaFinalPort"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [(!_vm.ffExoprtDetail.PODLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.PODLocationId))]) : _vm._e()])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Free Detention Days at Destination(Import Port)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "id": "freeDetentionDesti",
      "name": "freeDetentionDesti"
    },
    model: {
      value: (_vm.ffExoprtDetail.freeDetentionDesti),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "freeDetentionDesti", $$v)
      },
      expression: "ffExoprtDetail.freeDetentionDesti"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Last Free Days")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "id": "lastFreeDay",
      "name": "lastFreeDay",
      "disabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.lastFreeDay),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "lastFreeDay", $$v)
      },
      expression: "ffExoprtDetail.lastFreeDay"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remarks",
      "name": "remarks"
    },
    model: {
      value: (_vm.ffExoprtDetail.ffExportremarks),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ffExportremarks", $$v)
      },
      expression: "ffExoprtDetail.ffExportremarks"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (_vm.multipleHouseBLData.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "75"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('h4', {
    staticClass: "showMoreData",
    on: {
      "click": _vm.showMoreShipper
    }
  }, [_vm._v("Click here to " + _vm._s(_vm.openShipper == true ? "Hide" : "Add More") + " House BL")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "80"
    }
  }, [_c('h3', [_vm._v("House B/L Wise :")])])], 1), _vm._v(" "), (_vm.multipleHouseBLData.length == 0 || _vm.openShipper == true) ? _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Importer Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Importer Name"
    },
    model: {
      value: (_vm.ffHouseBL.importerClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "importerClientId", $$v)
      },
      expression: "ffHouseBL.importerClientId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Exporter Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Exporter Name"
    },
    model: {
      value: (_vm.ffHouseBL.exporterClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "exporterClientId", $$v)
      },
      expression: "ffHouseBL.exporterClientId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "finalPlaceLocationId"
    }
  }, [_vm._v("Final Place of Delivery")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Final Place of Delivery"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      }
    },
    model: {
      value: (_vm.ffHouseBL.finalPlaceLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "finalPlaceLocationId", $$v)
      },
      expression: "ffHouseBL.finalPlaceLocationId"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [(!_vm.ffHouseBL.importerClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.importerClientId))]) : _vm._e()]), _vm._v(" "), (!_vm.ffHouseBL.exporterClientId) ? _c('span', {
    staticClass: "error pl-2 pr-2"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.exporterClientId))]) : _vm._e(), _vm._v(" "), (!_vm.ffHouseBL.finalPlaceLocationId) ? _c('span', {
    staticClass: "error pl-2 pr-2"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.finalPlaceLocationId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('h4', {
    staticClass: "showMoreData",
    staticStyle: {
      "margin": "0px"
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("Add New Client")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("House B/L Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "secondBLNumber",
      "name": "secondBLNumber"
    },
    on: {
      "keyup": _vm.houseBLRegexfun
    },
    model: {
      value: (_vm.ffHouseBL.secondBLNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondBLNumber", $$v)
      },
      expression: "ffHouseBL.secondBLNumber"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("House B/L Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "width": "100%",
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "secondBLDate",
      "name": "secondBLDate"
    },
    model: {
      value: (_vm.ffHouseBL.secondBLDate),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondBLDate", $$v)
      },
      expression: "ffHouseBL.secondBLDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "secondBlType"
    }
  }, [_vm._v("B/L Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.blTypeList,
      "option-value": "blTypeVal",
      "option-text": "blTypeTxt",
      "placeholder": "Select B/L Type",
      "isDisabled": true
    },
    model: {
      value: (_vm.ffHouseBL.secondBlType),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondBlType", $$v)
      },
      expression: "ffHouseBL.secondBlType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary",
    staticStyle: {
      "margin": "0",
      "align-self": "end",
      "padding-bottom": "0.7rem"
    },
    attrs: {
      "id": "permitted1",
      "name": "permitted1",
      "md-value": "Original"
    },
    model: {
      value: (_vm.ffHouseBL.secondBLRadio),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondBLRadio", $$v)
      },
      expression: "ffHouseBL.secondBLRadio"
    }
  }, [_vm._v("Original")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary",
    staticStyle: {
      "margin": "0",
      "align-self": "end",
      "padding-bottom": "0.7rem"
    },
    attrs: {
      "id": "permitted2",
      "name": "permitted2",
      "md-value": "seaWayBl"
    },
    model: {
      value: (_vm.ffHouseBL.secondBLRadio),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondBLRadio", $$v)
      },
      expression: "ffHouseBL.secondBLRadio"
    }
  }, [_vm._v("Sea Way")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(!_vm.ffHouseBL.secondBLNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.secondBLNumber))]) : (_vm.houseblRegexError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.houseblRegexError))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "secondOcFreghtTerms"
    }
  }, [_vm._v("Ocean Freight")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.oceanFreightTermsList,
      "option-value": "oceanFreightTermsVal",
      "option-text": "oceanFreightTermsText",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.ffHouseBL.secondOcFreghtTerms),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondOcFreghtTerms", $$v)
      },
      expression: "ffHouseBL.secondOcFreghtTerms"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload B/L")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "secondBLupload",
      "id": "secondBLupload",
      "multiple": ""
    },
    on: {
      "selected": _vm.onFileChangeSecondBl
    },
    model: {
      value: (_vm.ffHouseBL.secondBLupload),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondBLupload", $$v)
      },
      expression: "ffHouseBL.secondBLupload"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.SecondBlUploadView.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), _vm._l((_vm.SecondBlUploadView), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "15"
      }
    }, [(_vm.ffHouseBL.conSeaMultiBlId == '') ? _c('a', {
      attrs: {
        "href": (this.docURL) + "/dummy/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('a', {
      attrs: {
        "href": (this.docURL) + "/SeaImportCon/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Delivery Terms(INCOTERMS)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryTermsList,
      "option-value": "deliveryTermsVal",
      "option-text": "deliveryTermsText",
      "placeholder": "Select Delivery Terms"
    },
    model: {
      value: (_vm.ffHouseBL.deliveryTerms),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "deliveryTerms", $$v)
      },
      expression: "ffHouseBL.deliveryTerms"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("Custom Clearence Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select  Type"
    },
    model: {
      value: (_vm.ffHouseBL.ccType),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "ccType", $$v)
      },
      expression: "ffHouseBL.ccType"
    }
  })], 1), _vm._v(" "), (_vm.ffHouseBL.ccType == 'Outsourced') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("CHA Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "ccCha",
      "name": "ccCha"
    },
    model: {
      value: (_vm.ffHouseBL.ccCha),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "ccCha", $$v)
      },
      expression: "ffHouseBL.ccCha"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), (!_vm.ffHouseBL.ccType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.ccType))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "shipmentType"
    }
  }, [_vm._v("Source Of Booking")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipTypeList,
      "option-value": "shipTypeVal",
      "option-text": "shipTypeText",
      "placeholder": "Select Source Of Booking "
    },
    model: {
      value: (_vm.ffHouseBL.shipType),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "shipType", $$v)
      },
      expression: "ffHouseBL.shipType"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffHouseBL.shipType == 'Destination') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "agentName"
    }
  }, [_vm._v("Agent Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.agentNameList,
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Agent Name"
    },
    model: {
      value: (_vm.ffHouseBL.agentName),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "agentName", $$v)
      },
      expression: "ffHouseBL.agentName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffHouseBL.shipType == 'Origin') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "sourceOriginclientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    model: {
      value: (_vm.ffHouseBL.sourceOriginclientId),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "sourceOriginclientId", $$v)
      },
      expression: "ffHouseBL.sourceOriginclientId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffHouseBL.shipType == 'Destination') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Buyer Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyer",
      "name": "buyer"
    },
    model: {
      value: (_vm.ffHouseBL.buyer),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "buyer", $$v)
      },
      expression: "ffHouseBL.buyer"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffHouseBL.shipType == 'Origin') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Enter Buying House")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyingHouse",
      "name": "buyingHouse"
    },
    model: {
      value: (_vm.ffHouseBL.buyingHouse),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "buyingHouse", $$v)
      },
      expression: "ffHouseBL.buyingHouse"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffHouseBL.shipType == 'Origin') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Other Specify")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherSpecify",
      "name": "otherSpecify"
    },
    model: {
      value: (_vm.ffHouseBL.otherSpecify),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "otherSpecify", $$v)
      },
      expression: "ffHouseBL.otherSpecify"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.ffHouseBL.notifyList), function(singleInput, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "25"
      }
    }, [_c('md-layout', {
      staticClass: "pl-2 pr-2",
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "80"
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.notifyArray[index]) + " Notify Name & Address")])]), _vm._v(" "), (index > 1) ? _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      staticStyle: {
        "min-height": "20px",
        "height": "20px"
      },
      on: {
        "click": function($event) {
          _vm.removeNotify(index)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      staticClass: "pl-2 pr-2",
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('quill-editor', {
      ref: "myTextEditor",
      refInFor: true,
      model: {
        value: (singleInput.inputValue),
        callback: function($$v) {
          _vm.$set(singleInput, "inputValue", $$v)
        },
        expression: "singleInput.inputValue"
      }
    })], 1)], 1)], 1)
  })), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    staticClass: "showMoreData",
    on: {
      "click": _vm.addNotify
    }
  }, [_vm._v("Add Notify")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Marks & Nos.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "houseMarksNos",
      "name": "houseMarksNos"
    },
    model: {
      value: (_vm.ffHouseBL.houseMarksNos),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseMarksNos", $$v)
      },
      expression: "ffHouseBL.houseMarksNos"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Container No./ Seal No.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "houseContainerSealNo",
      "name": "houseContainerSealNo"
    },
    model: {
      value: (_vm.ffHouseBL.houseContainerSealNo),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseContainerSealNo", $$v)
      },
      expression: "ffHouseBL.houseContainerSealNo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v("Commodity Name, HSN Code and Type")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "houseCommodity",
      "name": "houseCommodity"
    },
    model: {
      value: (_vm.ffHouseBL.houseCommodity),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseCommodity", $$v)
      },
      expression: "ffHouseBL.houseCommodity"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("No. Of Containers/Packages")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "houseNoOfPkg",
      "name": "houseNoOfPkg"
    },
    model: {
      value: (_vm.ffHouseBL.houseNoOfPkg),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseNoOfPkg", $$v)
      },
      expression: "ffHouseBL.houseNoOfPkg"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Gross Wgt. of Cargo")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "houseGrossWeightCargo",
      "name": "houseGrossWeightCargo"
    },
    model: {
      value: (_vm.ffHouseBL.houseGrossWeightCargo),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseGrossWeightCargo", $$v)
      },
      expression: "ffHouseBL.houseGrossWeightCargo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Net Wgt. of Cargo")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "Measurement",
      "name": "Measurement"
    },
    model: {
      value: (_vm.ffHouseBL.houseVolumeWeightCargo),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseVolumeWeightCargo", $$v)
      },
      expression: "ffHouseBL.houseVolumeWeightCargo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Measurement(CBM)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "Measurement",
      "name": "Measurement"
    },
    model: {
      value: (_vm.ffHouseBL.houseFinalChargeableWeight),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseFinalChargeableWeight", $$v)
      },
      expression: "ffHouseBL.houseFinalChargeableWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Description of Goods")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "houseDescriptionGood",
      "name": "houseDescriptionGood"
    },
    model: {
      value: (_vm.ffHouseBL.houseDescriptionGood),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseDescriptionGood", $$v)
      },
      expression: "ffHouseBL.houseDescriptionGood"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remarks",
      "name": "remarks"
    },
    model: {
      value: (_vm.ffHouseBL.remarks),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "remarks", $$v)
      },
      expression: "ffHouseBL.remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px mrgtop-2per",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.addFFSeaImport('')
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1), _vm._v(" "), (_vm.multipleHouseBLData.length > 0) ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.multipleHouseBLData.length > 0) ? _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "conBooking"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("House BL Number")]), _vm._v(" "), _c('th', [_vm._v("Importer Name")]), _vm._v(" "), _c('th', [_vm._v("Exporter Name")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multipleHouseBLData), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.EditHouseBL(item1)
        }
      }
    }, [_vm._v(_vm._s(item1.secondBLNumber == null || item1.secondBLNumber == "" ? "N/A" : item1.secondBLNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ImporterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ExporterName))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.multipleHouseBLData.length > 0 && _vm.ffHouseBL.conSeaMultiBlId == '') ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e(), _vm._v(" "), (_vm.multipleHouseBLData.length > 0 && _vm.ffHouseBL.conSeaMultiBlId == '') ? _c('md-layout', {
    staticClass: "mrgtop-button",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px mrgtop-2per",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.addFFSeaImport('fdsf')
      }
    }
  }, [_vm._v("Proceed to Execution")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertAddSeaImp",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAddSeaImp
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4be4b64c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/conSeaImport/ffConSeaImportFcl.vue
// module id = 2603
// module chunks = 0